import onReady from '../utils/onReady';
import * as ClassList from '../utils/classList';
import * as Events from '../utils/events';
import Accordion from './accordion';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class CourseSignUp {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    addEvents() {
        this.dom.container.addEventListener("submit", event => {
            event.preventDefault();
            this.handleSubmit();
        });
    }


    handleSubmit() {
        let participant = this.getData(this.dom.container);
        this.addParticipant(participant);
    }

    /**
     * Get data from form and make an participant object
     *
     * @param {HTMLElement} formElement
     * @return {Object} Participant object containing form info
     */
    getData(formElement) {
        let participant = {};

        Array.from(formElement.elements).forEach( element => {
            if (element.name === "") {
                return;
            }

            // If the input field is a checkbox, we need to access its checked state, rather than value
            if (element.type && element.type === 'checkbox') {
                participant[element.name] = element.checked;
            } else {
                participant[element.name] = element.value;
            }
        });

        return participant;
    }

    /**
     * Add participant to DOM
     *
     * @param {Object} participant
     */
    addParticipant(participant) {
        if (!ClassList.contains(this.dom.formCourseCombined, "form-course-combined--active")) {
            ClassList.add(this.dom.formCourseCombined, "form-course-combined--active");
        }

        let participantItem = document.createElement("div"),
            inputFieldItemArray = [],
            participantMarkup = `
            <div class="accordion__header">
                <p class="accordion__toggle">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>
                </p>
                <p class="box__text box__text--bold box__text--no-margin">${participant.name} - ${participant.timeAndPlace}</p>
            </div>

            <div class="accordion__content form-course__participant">
                <p class="box__text box__text--margin-small">${participant.address}</p>
                <div class="form-course__participants--inline">
                    <p class="box__text box__text--margin-small">${participant.postalCode}</p>
                    <p class="box__text box__text--margin-small">${participant.city}</p>
                </div>
                <p class="box__text box__text--margin-small">${decodeURIComponent(participant.email)}</p>
                <p class="box__text box__text--margin-small">${participant.tel}</p>
                ${ participant.landline ? '<p class="box__text box__text--margin-small">Har kun fastnet-telefon</p>' : ''}
                ${ participant.walkingDifficulty ? '<p class="box__text box__text--margin-small">Gangbesværet</p>' : ''}
                
                ${ participant.extraText !== "" ? `<p class="pre-text">Andet</p><p class="box__text box__text--margin-small">${participant.extraText}</p>` : ''}

                <p class="box__text">
                    <a href="javascript:;" class="delete-participant">Slet deltager</a>
                </p>
            </div>
            `;

        // Add classes and content to participantItem
        ClassList.add(participantItem, "accordion");
        ClassList.add(participantItem, "accordion--reverse");
        participantItem.innerHTML = participantMarkup;

        // Create an input element for each key in our participant object
        for (let key in participant) {
            if (participant.hasOwnProperty(key)) {
                inputFieldItemArray.push(document.createElement("input"));

                let index = inputFieldItemArray.length - 1;

                inputFieldItemArray[index].type = "hidden";
                inputFieldItemArray[index].name = "participant" + this.capitalizeFirstLetter(key) + "[]";
                inputFieldItemArray[index].value = participant[key];
            }
        }

        // Add participant and hidden input fields to DOM
        this.dom.participantContainer.appendChild(participantItem);
        inputFieldItemArray.forEach( element => {
            this.dom.participantContainer.appendChild(element);
        });

        // Make the participant an Accordion
        let participantElement = new Accordion(participantItem);


        // Show that a participant has been added
        this.dom.confirmationMessage.innerHTML = participant.name + "<span> tilføjet</span>";
        ClassList.remove(this.dom.confirmationMessage, "hidden");

        // Find the delete button/link
        let deleteParticipant = participantItem.querySelector(".delete-participant");

        // Delete participant on delete click
        Events.addEventOnce(deleteParticipant, "click", () => {
            participantElement.delete();
            participantItem.parentNode.removeChild(participantItem);

            // Show that participant has been deleted
            this.dom.confirmationMessage.innerHTML = participant.name + "<span> fjernet</span>";

            inputFieldItemArray.forEach( element => {
                element.parentNode.removeChild(element);
            });
        });

        this.clearForm(this.dom.container);
    }

    clearForm(formElement) {
        Array.from(formElement.elements).forEach( element => {
            if (element.name === "") {
                return;
            }

            element.value = "";
            element.checked = false;
        });
    }


    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container"
            formCourseCombined: document.getElementById("form-course-combined"),
            participantContainer: document.querySelector(".form-course__participants"),
            confirmationMessage: container.querySelector(".form-course__confirmation")
        };

        // Put your other DOM-specific initializations here, and get your class moving!

        this.addEvents();
    }

}


export default CourseSignUp;